import { BUTTON_ANIMATIONS } from '@elo-kit/constants/animations.constants'
import { BUTTON_STYLE } from '@elo-kit/constants/contentPage.constants'
import { COLORS } from '@elo-kit/constants/general.constants'

import { FORM_KEYS } from './embeddableItemsShared.constants'

export * from './embeddableItemsShared.constants'

export const CREATION_STEPS = {
  formSelection: 'formSelection',
  affiliateProgram: 'affiliateProgram',
  detailsStep: 'detailsStep',
  redirectionStep: 'redirectionStep',
  paramsFormStep: 'paramsFormStep',
  customizationStep: 'customizationStep',
  previewStep: 'previewStep',
}

export const FORM_ICONS = {
  plainLink: 'fas fa-link',
  textLink: 'fas fa-font',
  button: 'fas fa-power-off',
  banner: 'fas fa-image',
  badge: 'fas fa-file-image',
  slider: 'fas fa-images',
  embedForm: 'fas fa-window-maximize',
  embedPaymentPage: 'fas fa-credit-card',
}

export const FORM_COLORS = {
  plainLink: 'light-blue',
  textLink: 'pink',
  button: 'blue',
  banner: 'orange',
  badge: 'red',
  slider: 'light-green',
  embedForm: 'violet',
  embedPaymentPage: 'green',
}

export const PURPOSE_ICONS = {
  shop: 'fas fa-shopping-basket',
  product: 'fas fa-archive',
  course_lesson: 'fas fa-graduation-cap',
  login_page: 'fas fa-sign-in-alt',
  custom_link: 'fas fa-link',
}

export const PREVIEW_TYPE_KEYS = {
  product: 'product',
  course: 'course',
  seller: 'seller', // For loginPage purpose or shop
  customLink: 'customLink',
  productWithAffiliate: 'productWithAffiliate',
}

export const BUTTON_ALIGNMENTS = {
  left: 'left',
  right: 'right',
  center: 'center',
}

export const POSITIONS = {
  left: 'flex-start',
  right: 'flex-end',
  center: 'center',
}

export const DEFAULT_STYLE_PREFS = {
  [FORM_KEYS.textLink]: {
    text: 'Lorem ipsum dolor sit amet',
    fontFamily: 'Montserrat Reg',
    fontStyle: 'normal',
    fontColor: COLORS.eloBlue,
    fontSize: 24,
  },
  [FORM_KEYS.button]: {
    buttonText: I18n.t('react.shared.button.buy_now').toUpperCase(),
    buttonFontFamily: 'Montserrat Medium',
    buttonFontStyle: 'bold',
    buttonFontColor: COLORS.eloWhite,
    buttonFontSize: 20,
    buttonColor: COLORS.eloLightGreen,
    buttonHoverColor: COLORS.eloLightGreen,
    buttonBorderRadius: 6,
    buttonStyle: BUTTON_STYLE.filled,
    buttonAnimation: BUTTON_ANIMATIONS.transparency,
  },
  [FORM_KEYS.badge]: {
    badgeColor: COLORS.eloWhite,
    badgeBorderRadius: 6,
    badgeFontFamily: 'Montserrat Reg',
    badgeFontStyle: 'bold',
    badgeFontColor: COLORS.eloBlack,
    badgeFontSize: 14,
    buttonText: I18n.t('react.shared.button.buy_now'),
    buttonFontFamily: 'Montserrat Reg',
    buttonFontStyle: 'normal',
    buttonFontColor: COLORS.eloWhite,
    buttonFontSize: 12,
    buttonColor: COLORS.eloOrange,
    buttonHoverColor: COLORS.eloDarkOrange,
    buttonBorderRadius: 30,
    buttonStyle: BUTTON_STYLE.filled,
    buttonAnimation: BUTTON_ANIMATIONS.transparency,
    priceBackgroundColor: COLORS.eloBlue,
    priceFontColor: COLORS.eloWhite,
    priceTagEnabled: true,
    buttonAlignment: BUTTON_ALIGNMENTS.center,
    tagBackground: COLORS.eloBlue,
    tagFontColor: COLORS.eloWhite,
  },
  [FORM_KEYS.slider]: {
    badgeColor: COLORS.eloWhite,
    badgeBorderRadius: 6,
    badgeFontFamily: 'Montserrat Reg',
    badgeFontStyle: 'bold',
    badgeFontColor: COLORS.eloBlack,
    badgeFontSize: 14,
    buttonText: I18n.t('react.shared.button.buy_now'),
    buttonFontFamily: 'Montserrat Reg',
    buttonFontStyle: 'normal',
    buttonFontColor: COLORS.eloWhite,
    buttonFontSize: 12,
    buttonColor: COLORS.eloOrange,
    buttonHoverColor: COLORS.eloDarkOrange,
    buttonBorderRadius: 30,
    buttonStyle: BUTTON_STYLE.filled,
    buttonAnimation: BUTTON_ANIMATIONS.transparency,
    priceBackgroundColor: COLORS.eloBlue,
    priceFontColor: COLORS.eloWhite,
    priceTagEnabled: true,
    buttonAlignment: BUTTON_ALIGNMENTS.center,
    tagBackground: COLORS.eloBlue,
    tagFontColor: COLORS.eloWhite,
    sliderBackgroundOpacity: 100,
    sliderShadowOpacity: 15,
    arrowColor: COLORS.eloOrange,
  },
  [FORM_KEYS.embedForm]: {
    embedFormContainerMaxWidth: 600,
    embedFormContainerOpacity: 100,
    embedFormShadowOpacity: 15,
    embedFormContainerRadius: 4,
    embedFormColor: COLORS.eloWhite,
    titleFontFamily: 'Montserrat Reg',
    titleFontStyle: 'bold',
    titleFontColor: COLORS.eloBlack,
    titleFontSize: 18,
    regCtaFontFamily: 'Montserrat Reg',
    regCtaFontColor: COLORS.eloBlue,
    buttonText: I18n.t('shared.common.accept'),
    buttonFontFamily: 'Montserrat Reg',
    buttonFontStyle: 'normal',
    buttonFontColor: COLORS.eloWhite,
    buttonFontSize: 13,
    buttonColor: COLORS.eloOrange,
    buttonHoverColor: COLORS.eloDarkOrange,
    buttonBorderRadius: 17,
    buttonStyle: BUTTON_STYLE.filled,
    buttonAnimation: BUTTON_ANIMATIONS.transparency,
    buttonAlignment: BUTTON_ALIGNMENTS.right,
    locale: I18n.locale,
    labelsEnabled: true,
    labelFontFamily: 'Montserrat Reg',
    labelFontStyle: 'bold',
    labelColor: COLORS.eloGrey70,
    labelSize: 13,
  },
}

export const EMBEDDABLE_ITEMS_CSV_PARAMS = [
  {
    label: I18n.t('react.cabinet.common.id'),
    csvKey: 'id',
  },
  {
    label: I18n.t('react.cabinet.common.name'),
    csvKey: 'name',
  },
  {
    label: I18n.t('react.cabinet.common.notes'),
    csvKey: 'description',
  },
  {
    label: I18n.t('react.cabinet.common.product_name'),
    csvKey: 'product',
  },
  {
    label: I18n.t('shared.common.created'),
    csvKey: 'created',
  },
  {
    label: I18n.t('react.cabinet.common.link'),
    csvKey: 'link',
  },
  {
    label: I18n.t('react.cabinet.product.link.short_link'),
    csvKey: 'short_link',
  },
  {
    label: I18n.t('react.cabinet.product.link.embed_code'),
    csvKey: 'embed_code',
  },
  {
    label: I18n.t('react.shared.linked_to'),
    csvKey: 'purpose',
  },
  {
    label: I18n.t('react.shared.views'),
    csvKey: 'views',
  },
]
